import { useEffect, useState } from "react"

// Subscribes to a CSS media query. Returns false during SSR-less first paint
// only if the query genuinely doesn't match — the initial read is synchronous
// (lazy useState initialiser), so there is no flash of the wrong layout.
//
// Guarded for environments without matchMedia (jsdom in a future test setup,
// very old browsers): those report false and get the desktop layout, which is
// the safe default — the mobile shell is the specialised branch.
export default function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false
    return window.matchMedia(query).matches
  })

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return
    const mql = window.matchMedia(query)
    const onChange = (e) => setMatches(e.matches)
    // Re-read on subscribe: the query can have changed between the initial
    // render and this effect (an orientation flip during hydration).
    setMatches(mql.matches)
    mql.addEventListener("change", onChange)
    return () => mql.removeEventListener("change", onChange)
  }, [query])

  return matches
}
